<template>
  <div>
    <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
    <Header/>

    <div class="barra-agenda">

      <!-- IZQUIERDA -->
      <div class="grupo izquierda">
        <label class="label-principal">CLÍNICA</label>
        <v-select
            class="select-clinica"
            :clearable="false"
            :options="listaClinicas"
            v-model="datosBusqueda.clinica.idClinica"
            :reduce="(v) => v.id"
            label="nombre"
            @input="actualizarNombreClinica(false)"
        />
      </div>

      <!-- CENTRO -->
      <div class="grupo centro">
        <button class="btn-tab activo" @click="buscarHorarios()">SEMANAL</button>
        <button class="btn-tab" @click="buscarHorarios()" disabled>DIARIA</button>

        <!-- navegación -->
        <div class="nav-semana">
          <button class="nav-btn" @click="cambiarAnteriorSemana()">‹</button>
          <span class="rango-semana">{{ rangoSemanaTexto }}</span>
          <button class="nav-btn" @click="cambiarSiguienteSemana()">›</button>
        </div>
      </div>

      <!-- DERECHA -->
      <div class="grupo derecha">

        <!-- tabs -->
        <div class="tabs">
          <span class="tab" @click="buscarHorarios()" style="cursor:pointer;"><em class="icon-tab icon_paciente"></em> PACIENTES</span>
          <span class="tab" @click="buscarHorarios()" style="cursor:pointer;"><em class="icon-tab icon_doctor"></em> DOCTORES</span>
          <span class="tab activo" @click="abrirModalSillon(null, null)" style="cursor:pointer;"><em class="icon-tab icon_sillon"></em>SILLONES</span>
          <span class="tab" @click="buscarHorarios()" style="cursor:pointer;"><em class="icon-tab icon_embajador"></em>SILLÓN EMBAJADOR</span>
          <span class="tab" @click="buscarHorarios()" style="cursor:pointer;"><em class="icon-tab icon_administracion"></em>CITA ADMINISTRATIVA</span>
        </div>

      </div>

    </div>

    <table class="agenda-table">
      <thead>
      <tr>
        <th class="hora-col">SEMANA</th>
        <th v-for="diaSemana in semana.dias" :key="diaSemana.diaNumero">
          <div class="dia-header" :class="esDiaActual(diaSemana.fecha) ? 'dia-actual' : 'dia-otro'">
            <div class="dia-nombre">{{ obtenerNombreDia(diaSemana.fecha) }}</div>
            <div class="dia-fecha">{{ obtenerDiaMes(diaSemana.fecha) }}</div>
          </div>
        </th>
      </tr>
      </thead>

      <tbody>
      <tr
          v-for="hora in semana.horas"
          :key="hora.posicion"
      >
        <td class="hora-col">{{ hora.horaEtiqueta }}</td>

        <td
            v-for="(casilla) in casillas[hora.posicion]"
            :key="casilla.diaSemana"
            class="celda"
        >
          <div class="contenedor-salas">
            <div
                v-for="sala in salasConfiguradas(casilla.salas)"
                :key="sala.numeroSala"
                class="sala-box"
                :class="{
                  disponible: sala.sillon_habilitado,
                  noDisponible: !sala.sillon_habilitado
                }"
                @click="abrirModalSillon(casilla, sala)"
            >
              <span class="sala-label">S{{ sala.numeroSala }}</span>
              <font-awesome-icon
                :icon="sala.sillon_habilitado ? 'check-circle' : 'times-circle'"
                class="sala-icon"
              />
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <b-modal v-model="configurarSillon"
             :title=tituloModal
             size="lg"
             hide-footer
             no-close-on-backdrop>
      <ModalCrearHorarioSillon :modo="modoModal"
                               :listaSillones="listaSillones"
                               :nombreClinica="datosBusqueda.clinica.nombre"
                               :idClinica="datosBusqueda.clinica.idClinica"
                               :diasOperativos="diasOperativos"
                               :listaDias="listaDias"
                               :seleccionInhabilitar="seleccionInhabilitar"
                               :listaHorariosSillon="eventos"
                               @guardarHorarioSillon="guardarHorarioSillon"
                               @inhabilitarHorario="inhabilitarHorario"
                               @cerrarModalSillon="cerrarModalSillon()"
                               v-if="configurarSillon">
      </ModalCrearHorarioSillon>
    </b-modal>
  </div>
</template>

<script>

import Header from "@/components/Header.vue";
import ModalCrearHorarioSillon from "@/components/horarioSillon/ModalCrearHorarioSillon.vue";

export default {
  name: "horarioSillon",
  components: {Header, ModalCrearHorarioSillon},
  props: {},

  data: () => ({
    loading: false,
    dias: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    semana: {},
    casillasSalas: [],
    casillas: [],
    fechaInicio: undefined,
    fechaFin: undefined,
    numeroSalas: undefined,
    numeroSillones: 0,

    listaClinicas: [],
    datosBusqueda: {
      clinica: {
        idClinica: null,
        nombre: '-'
      },
      clinicaNombre: '-',
      fechaInicio: undefined,
      fechaFin: undefined,
      fechaActual: new Date(),
      empleadoId: null,
    },
    eventos: [],

    configurarSillon: false,
    tituloModal: null,
    modoModal: 'crear',
    listaSillones: [],

    diasOperativos: [],
    listaDias: [],

    seleccionInhabilitar: {
      sillonSeleccionado: null,
      fechaSelecionada: null,
      habilitado: false
    },
  }),

  computed: {
    ancho() {
      if (this.numeroSalas <= 4) {
        return "width:30px;";
      } else {
        return "width:" + (130 / (this.numeroSalas +2)) + "px; font-size:8px;";
      }
    },

    rangoSemanaTexto() {
      if (!this.datosBusqueda.fechaInicio || !this.datosBusqueda.fechaFin) return '';

      const inicio = this.$moment(this.datosBusqueda.fechaInicio).format('D [de] MMMM');
      const fin = this.$moment(this.datosBusqueda.fechaFin).format('D [de] MMMM');

      return `${inicio} - ${fin}`;
    }

  },

  created() {
    if (this.$localStorageService.getIdEmpleado() !== undefined) {
      this.datosBusqueda.clinica.empleadoId = this.$localStorageService.getIdEmpleado();
    }
    if (this.$localStorageService.getIdClinica() !== undefined) {
      this.datosBusqueda.clinica.idClinica = this.$localStorageService.getIdClinica();
    }

    this.fechaActual = new Date();
    this.llenarClinicas();
    this.idUsuario = this.$localStorageService.getIdUsuario();

  },

  methods: {
    obtenerNombreDia(fecha) {
      return this.dias[new Date(fecha).getDay()];
    },

    obtenerDiaMes(fecha) {
      return this.$moment(fecha).format('D [de] MMMM');
    },

    esDiaActual(fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD') === this.$moment().format('YYYY-MM-DD');
    },
    cambiarAnteriorSemana() {
      let fecha = new Date(this.datosBusqueda.fechaInicio);
      fecha.setDate(fecha.getDate() - 7);

      this.seleccionarFecha(fecha);
      this.obtenerHorariosSillonesClinica();
    },

    cambiarSiguienteSemana() {
      let fecha = new Date(this.datosBusqueda.fechaInicio);
      fecha.setDate(fecha.getDate() + 7);

      this.seleccionarFecha(fecha);
      this.obtenerHorariosSillonesClinica();
    },

    llenarClinicas() {
      this.obtenerNumeroSillones();

      this.loading = true;
      this.$http.get(this.$api + "catalogos/listaClinicas").then(response => {
        if (response.status === 200) {
          this.listaClinicas = response.data.data.map(it => {
            return {
              id: it.idClinica,
              nombre: it.strNombre,
              numeroSillones: it.numeroSillones,
            };
          }).filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
          this.actualizarNombreClinica(true);
        }
      }).finally(()=>{
        this.loading = false;
      });
    },

    actualizarNombreClinica(inicializar) {
      if (this.listaClinicas !== undefined) {
        const clinicaSelec = this.listaClinicas.find(it => it.id === this.datosBusqueda.clinica.idClinica);
        if (clinicaSelec !== undefined && clinicaSelec !== null) {
          this.datosBusqueda.clinica.nombre = clinicaSelec.nombre;

          if (inicializar) {
            const fechaActual = new Date();
            this.seleccionarFecha(fechaActual);
          } else {
            this.obtenerNumeroSillonesYBuscar();
          }
        }
      }
    },

    buscarHorarios() {
      this.calcularSemana(this.datosBusqueda.fechaInicio, [], this.numeroSillones);
      this.obtenerHorariosSillonesClinica();
    },

    calcularSemana(fechaRecibida, eventos, numero) {
      let fecha = new Date();
      fecha = new Date(fechaRecibida.toISOString());

      this.numeroSalas = numero;

      this.semana = {};

      const mesSemana = this.$moment(fecha.toISOString()).format('MMMM YYYY');

      this.semana.numeroSemana = "Semana " + this.$moment(fecha.toISOString()).week() + " (" + mesSemana.charAt(0).toUpperCase() + mesSemana.slice(1) + ")";

      this.semana.dias = Array();
      fecha.setDate(fecha.getDate() - fecha.getDay());

      this.fechaInicio = this.$moment(fecha.toISOString()).format("YYYY/MM/DD");
      this.llenarCasillas(fecha);

      for (let i = 0; i < 7; i++) {

        this.semana.dias.push({
          fecha: new Date(fecha),
          diaEtiqueta: this.dias[fecha.getDay()] + " " + this.$moment(fecha.toISOString()).format('DD') + " de " + this.obtenerNombreMesPorNumeroMes(Number(this.$moment(fecha.toISOString()).format('MM'))),
          diaNumero: fecha.getDay()
        });
        fecha.setDate(fecha.getDate() + 1);
      }

      this.fechaFin = this.$moment(fecha.toISOString()).format("YYYY/MM/DD");

      this.pintarEventos(eventos);
    },

    obtenerNombreMesPorNumeroMes(mes){
      let nombreMes;
      if(mes === 1){
        nombreMes = "Enero";
      } else if(mes === 2){
        nombreMes = "Febrero";
      } else if(mes === 3){
        nombreMes = "Marzo";
      } else if(mes === 4){
        nombreMes = "Abril";
      } else if(mes === 5){
        nombreMes = "Mayo";
      } else if(mes === 6){
        nombreMes = "Junio";
      } else if(mes === 7){
        nombreMes = "Julio";
      } else if(mes === 8){
        nombreMes = "Agosto";
      } else if(mes === 9){
        nombreMes = "Septiembre";
      } else if(mes === 10){
        nombreMes = "Octubre";
      } else if(mes === 11){
        nombreMes = "Noviembre";
      } else if(mes === 12){
        nombreMes = "Diciembre";
      }

      return nombreMes
    },

    pintarEventos(eventos) {

      this.semana.horas.forEach((hora) => {

        this.casillas[hora.posicion].forEach((casilla) => {

          casilla.salas.forEach((sala) => {

            let habilitado = false;
            let configurado = false;
            let idHorarioSillonClinica = null;

            const horaActual = Number(casilla.horaCasilla1);
            const fechaCasilla = casilla.fechaCasilla;

            for (let i = 0; i < eventos.length; i++) {
              const evento = eventos[i];
              const fechaEvento = evento.fecha.split("T")[0];

              if (
                  evento.sillon === sala.numeroSala &&
                  fechaEvento === fechaCasilla &&
                  horaActual >= evento.horaInicio &&
                  horaActual < evento.horaFin
              ) {
                if (evento.idHorarioSillonClinica) configurado = true;
                if (!evento.sillonHabilitado) {
                  idHorarioSillonClinica = evento.idHorarioSillonClinica;
                  habilitado = false;
                  break; // inhabilitado tiene prioridad, para aquí
                }
                habilitado = true; // habilitado pero sigue buscando por si hay inhabilitado
              }
            }

            sala.idHorarioSillonClinica = idHorarioSillonClinica
            sala.sillon_habilitado = habilitado;
            sala.configurado = configurado;

          });

        });

      });

      this.loading = false;
    },

    llenarCasillas(fechaInicio) {
      this.calcularHoras();
      this.casillas = Array();

      const diaActual = this.$moment().format('YYYY-MM-DD');

      this.semana.horas.forEach(horaSemana => {
        const fechaCasilla = new Date();
        fechaCasilla.setTime(fechaInicio.getTime());
        const casillas = Array();
        for (let i = 0; i < 7; i++) {

          const fechaCasillaFormato = this.$moment(fechaCasilla.toISOString()).format('YYYY-MM-DD');

          casillas.push({
            diaSemana: i,
            horaCasilla: horaSemana.horaEtiqueta,
            horaCasilla1: horaSemana.horaEtiqueta1,
            fechaCasilla: fechaCasillaFormato,
            esfechaActual:  fechaCasillaFormato === diaActual,
            salas: this.llenarSalas()
          });

          fechaCasilla.setDate(fechaCasilla.getDate() + 1);
        }

        this.casillas.push(casillas);
      });

    },

    llenarSalas() {
      const salas = Array();
      for (let i = 0; i < this.numeroSalas; i++) {
        salas.push({
          numeroSala: i + 1,
          horarioClinica: undefined,
          sillon_habilitado: false,
          configurado: false,
          idHorarioSillonClinica: null
        });
      }
      return salas;
    },

    calcularHoras() {
      this.semana.horas = Array();
      let fecha = new Date();
      fecha.setHours(7);
      fecha.setMinutes(0);
      fecha.setMilliseconds(0);

      for (let i = 0; i < 69; i++) {
        this.semana.horas.push({
          posicion: i,
          horaEtiqueta: this.$moment(fecha.toISOString()).format('HH:mm'),
          horaEtiqueta1: this.$moment(fecha.toISOString()).format('HHmm')
        });

        fecha.setMinutes(fecha.getMinutes() + 15);
      }

    },

    seleccionarFecha(date) {
      const fecha = new Date(date.toISOString());
      fecha.setHours(0);
      fecha.setMinutes(0);
      fecha.setMilliseconds(0);


      this.datosBusqueda.fechaInicio = new Date(fecha.toISOString());
      this.datosBusqueda.fechaInicio.setDate(fecha.getDate() - fecha.getDay());

      this.datosBusqueda.fechaFin = new Date(fecha.toISOString());
      this.datosBusqueda.fechaFin.setDate(fecha.getDate() + (7 - date.getDay()));

      this.buscarHorarios();
    },

    obtenerNumeroSillones() {
      this.loading = true;
      this.numeroSillones = 0;
      this.$http.post(this.$api + "horario/sillon/obtenerSillones", {idClinica: this.datosBusqueda.clinica.idClinica}).then(response => {
          this.numeroSillones = response.data.data.length;
          this.listaSillones = response.data.data;
      }).finally(()=>{
        this.loading = false;
      });
    },

    obtenerNumeroSillonesYBuscar() {
      this.loading = true;
      this.numeroSillones = 0;
      this.$http.post(this.$api + "horario/sillon/obtenerSillones", {idClinica: this.datosBusqueda.clinica.idClinica}).then(response => {
          this.numeroSillones = response.data.data.length;
          this.listaSillones = response.data.data;
          this.buscarHorarios();
        }).finally(() => {
          this.loading = false;
        });
    },

    salasConfiguradas(salas) {
      return salas.filter(s => s.configurado);
    },

    parseHora(valor) {
      if (valor === null || valor === undefined) {
        return { HH: '00', mm: '00' };
      }

      const str = valor.toString().trim();

      if (str.includes(':')) {
        const [HH, mm] = str.split(':');
        return {
          HH: HH.padStart(2, '0'),
          mm: (mm || '00').padStart(2, '0')
        };
      }

      const padded = str.padStart(4, '0');
      return {
        HH: padded.substring(0, 2),
        mm: padded.substring(2, 4)
      };
    },

    abrirModalSillon(casilla, sala){
      let horarioHabilitar = {
        horaInicio: null,
        horaFin: null,
        dia: null
      }
      this.seleccionInhabilitar = {
        sillonSeleccionado: null,
        fechaSelecionada: null,
        habilitado: false,
      }

      this.tituloModal = "Configuración de sillones";
      this.modoModal = 'crear';

      if (sala != null){
        this.seleccionInhabilitar.sillonSeleccionado = sala.numeroSala;
        this.tituloModal = sala.sillon_habilitado ? "Inhabilitación de sillones" : "Habilitación de sillones";
        this.modoModal = sala.sillon_habilitado ? 'inhabilitar' : 'habilitar';
        this.seleccionInhabilitar.habilitado = sala.sillon_habilitado;

        if (!sala.sillon_habilitado){
          horarioHabilitar = this.eventos.filter(evento => evento.idHorarioSillonClinica === sala.idHorarioSillonClinica)[0];
        }
      }

      if (casilla != null){
        this.seleccionInhabilitar.fechaSelecionada = casilla.fechaCasilla;
      }
      this.obtenerHorarioClinica(casilla != null ? casilla.diaSemana : null, horarioHabilitar);
    },

    cerrarModalSillon(){
      this.configurarSillon = false;
    },

    obtenerHorarioClinica(diaSemana, horarioHabilitar){
      this.loading = true;
      this.diasOperativos = [];
      this.listaDias =  [];

      this.$http.post(this.$api + "horarioCLinica/obtenerHorariosClinica", {filtroClinicaZona: this.datosBusqueda.clinica.nombre, esSillon: true}).then(response => {
        const datos = response.data.data[0];

        if (datos != null) {
          if (horarioHabilitar.dia != null){
            this.listaDias.push(this.regresarInicial(horarioHabilitar.dia, datos.listaHorariosInicio[0], datos.listaHorariosCierre[0]));
          }else{
            datos.listaHorariosClinicaDia.forEach(dia=>{
              this.listaDias.push(this.regresarInicial(dia.idDia,diaSemana, dia.horaInicio, dia.horaCierre));
            })
            this.listaDias.sort((a, b) => a.dia - b.dia);
          }

          if (horarioHabilitar.dia != null) {
            this.diasOperativos.push({
              dias: [],
              diaHabilitar: this.regresarInicial(horarioHabilitar.dia,null,null).nombreDia,
              horaInicio: horarioHabilitar.horaInicio,
              horaInicioPicker: this.parseHora(horarioHabilitar.horaInicio),
              horaFin: horarioHabilitar.horaFin,
              horaFinPicker: this.parseHora(horarioHabilitar.horaFin),
            });
          } else {
            for (var i = 0; i < datos.listaNombreDias.length; i++) {
              let diasHorariosAgrupados = {
                dias: datos.listaNombreDias[i],
                diaHabilitar: null,
                horaInicio: 0,
                horaInicioPicker: this.parseHora(0),
                horaFin: 0,
                horaFinPicker: this.parseHora(0),
              };
              this.diasOperativos.push(diasHorariosAgrupados);
            }
          }
        }
      }).finally(()=>{
        this.loading = false;
        this.configurarSillon = true;
      });
    },

    regresarInicial(dia, diaSemana, horaInicio, horaFin){
      let inicialDia;
      let nombreDia;
      if (dia === 1){
        inicialDia = "L";
        nombreDia = "Lunes";
      } else if (dia === 2) {
        inicialDia = "M";
        nombreDia = "Martes";
      } else if (dia === 3) {
        inicialDia = "M";
        nombreDia = "Miercoles";
      } else if (dia === 4) {
        inicialDia = "J";
        nombreDia = "Jueves";
      } else if (dia === 5) {
        inicialDia = "V";
        nombreDia = "Viernes";
      } else if (dia === 6) {
        inicialDia = "S";
        nombreDia = "Sabado";
      } else if (dia === 7) {
        inicialDia = "D";
        nombreDia = "Domingo";
      }
      let seleccionado = diaSemana === dia;
      return {dia: dia, inicialDia: inicialDia, seleccionado: seleccionado, nombreDia: nombreDia, horaInicio: horaInicio, horaFin: horaFin}
    },

    guardarHorarioSillon(sillon){
      this.loading = true;
      let params = {
        idClinica: this.datosBusqueda.clinica.idClinica,
        sillones: sillon.sillones,
        dias: sillon.dias,
        fechaInicio: this.$moment(sillon.fechaInicio).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        fechaFin: this.$moment(sillon.fechaFin).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        horaInicio: sillon.horaInicio,
        horaFin: sillon.horaFin,
      }
      this.$http.post(this.$api + "horario/sillon/habilitarSillon", params).then(response => {
        let mensaje = '';
        let titulo = 'Aviso';
        let guardadoExitoso = false;
        response.data.data.forEach((res, i)=>{
          if (!res.guardado && i < (response.data.data.length - 1)){
            mensaje = mensaje + '\nEl sillon ' + res.sillon + ' del dia ' + this.regresarInicial(res.dia).nombreDia + ' ' + res.mensaje + ', \n';
          } else if (!res.guardado && i === (response.data.data.length - 1)) {
            mensaje = mensaje + '\nEl sillon: ' + res.sillon + ' del dia ' + this.regresarInicial(res.dia).nombreDia + ' ' + res.mensaje;
          } else if (res.guardado){
            guardadoExitoso = true;
            titulo = 'Se habilitaron algunos registros, pero se obtuvieron los siguientes errores';
          }
        })
        if (mensaje === '') {
          this.$swal.fire({
            icon: 'success',
            title: 'El horario se habilito con éxito'
          });

          this.llenarClinicas();
          this.configurarSillon = false;
        }else{
          this.$swal.fire({
            icon: "warning",
            title: titulo,
            text: mensaje,
          });
          if (guardadoExitoso){
            this.llenarClinicas();
            this.configurarSillon = false;
          }
        }
      }).finally(()=>{
        this.loading = false;
      });
    },

    inhabilitarHorario(inhabilitarSillon){
      this.loading = true;
      let params = {
        idClinica: this.datosBusqueda.clinica.idClinica,
        sillones: inhabilitarSillon.sillones,
        dias: inhabilitarSillon.dias,
        fechaInicio: this.$moment(inhabilitarSillon.fechaInicio).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        fechaFin: this.$moment(inhabilitarSillon.fechaFin).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]"),
        horaInicio: inhabilitarSillon.horaInicio,
        horaFin: inhabilitarSillon.horaFin,
      }
      this.$http.post(this.$api + "horario/sillon/inhabilitarSillon", params).then(response => {
        let mensaje = '';
        let titulo = 'Aviso';
        let guardadoExitoso = false;
        response.data.data.forEach((res, i)=>{
          if (!res.guardado && i < (response.data.data.length - 1)){
            mensaje = mensaje + '\nEl sillon ' + res.sillon + ' del dia ' + this.regresarInicial(res.dia).nombreDia + ' ' + res.mensaje + ', ';
          } else if (!res.guardado && i === (response.data.data.length - 1)) {
            mensaje = mensaje + '\nEl sillon: ' + res.sillon + ' del dia ' + this.regresarInicial(res.dia).nombreDia + ' ' + res.mensaje;
          } else if (res.guardado){
            guardadoExitoso = true;
            titulo = 'Se inhabilitaron algunos registros, pero se obtuvieron los siguientes errores';
          }
        })
        if (mensaje === '') {
          this.$swal.fire({
            icon: 'success',
            title: 'El horario se inhabilito con éxito'
          });

          this.llenarClinicas();
          this.configurarSillon = false;
        }else{
          this.$swal.fire({
            icon: "warning",
            title: titulo,
            text: mensaje,
          });
          if (guardadoExitoso){
            this.llenarClinicas();
            this.configurarSillon = false;
          }
        }
      }).finally(()=>{
        this.loading = false;
      });
    },

    obtenerHorariosSillonesClinica(){
      if (!this.datosBusqueda.fechaInicio || !this.datosBusqueda.clinica.idClinica) return;
      this.loading = true;
      const params = {
        clinica: this.datosBusqueda.clinica.idClinica,
        fechaInicio: this.$moment(this.datosBusqueda.fechaInicio).utc().format('YYYY-MM-DD[T]HH:mm[:00Z]'),
      };
      this.$http.post(this.$api + "horario/sillon/obtenerHorarios", params).then(response => {
        this.eventos = response.data.data || [];
        this.pintarEventos(this.eventos);
      }).finally(()=>{
        this.loading = false;
      });
    },
  },
}
</script>

<style scoped>


.agenda-table {
  width: 99%;
  border-collapse: collapse;
  table-layout: fixed;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  margin: 0 auto;
}

/* HEADER */
.agenda-table th {
  background-color: white;
  font-size: 12px;
  padding: 10px;
  text-align: center;
  border: 1px solid #e0e0e0;
}

/* HORAS */
.hora-col {
  width: 80px;
  font-weight: bold;
  color: var(--color-azul-bienestar);
  border: 1px solid var(--color-principal-inactivo);
}

/* CELDAS */
.celda {
  height: 55px;
  border: 1px solid #e0e0e0;
  vertical-align: middle;
}

/* LÍNEA FUERTE CADA HORA */
.linea-fuerte td {
  border-top: 2px solid var(--color-principal-inactivo);
}

/* CONTENEDOR SALAS */
.contenedor-salas {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2px;
  padding: 2px;
}

/* SALAS */
.sala-box {
  width: 30px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  gap: 2px;
  cursor: pointer;
}

.sala-label {
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  color: white;
}

.sala-icon {
  font-size: 12px;
}

/* DISPONIBLE */
.disponible {
  background-color: var(--color-verda-frescura);
  color: white;
}

.disponible .sala-icon,
.noDisponible .sala-icon {
  color: #ffffff;
}

/* NO DISPONIBLE */
.noDisponible {
  background-color: var(--color-principal-inactivo);
  color: #ffffff;
}



.dia-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dia-otro .dia-nombre,
.dia-otro .dia-fecha {
  color: #b0b0b0;
  font-weight: 400;
}


.dia-nombre {
  font-size: 11px;
  font-weight: 700;
  color: var(--color-azul-bienestar);
}

.dia-fecha {
  font-size: 12px;
  font-weight: 700;
  color: #008FFF;
}


/*
  Barra Agenda
*/
.barra-agenda {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 20px;
  border-radius: 10px;
  background-color: #fff;
  border: solid #f5f5f5 1px;
  margin: 12px;
}

/* GRUPOS */
.grupo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.izquierda {
  display: flex;
  align-items: center;
  gap: 8px;
}

.select-clinica {
  width: 180px;
  min-width: 180px;
  font-size: 12px;
}

.select-clinica .vs__selected {
  color: var(--color-azul-bienestar);
  font-weight: 600;
}

.derecha {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-left: auto;
}

/* LABEL */
.label-principal {
  font-size: 11px;
  font-weight: bold;
  color: #666;
}

/* BOTONES SEMANAL / DIARIA */
.centro {
  display: flex;
  align-items: center;
  gap: 16px;
}

.centro .nav-semana {
  margin-left: 8px;
}

.btn-tab {
  padding: 4px 18px;
  font-size: 11px;
  border-radius: 8px;
  border: 1px solid var(--color-principal-inactivo);
}

.btn-tab.activo {
  background: var(--color-azul-bienestar);
  color: white;
}

/* NAVEGACIÓN SEMANA */
.nav-semana {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rango-semana {
  font-size: 12px;
  font-weight: bold;
  color: var(--color-azul-bienestar);
}

.nav-btn {
  border: 1px solid #d0d0d0;
  background: white;
  width: 25px;
  height: 25px;
  border-radius: 5px;
  cursor: pointer;
}

/* TABS */
.tabs {
  display: flex;
  gap: 24px;
}

.tab {
  font-size: 11px;
  color: #777;
  display: flex;
  gap: 8px;
  align-items: center;
}

.tab.activo {
  color: var(--color-azul-bienestar);
  font-weight: 600;
}

.icon-tab {
  width: 22px;
  height: 22px;
}
</style>
